/**
 * Types pour la gestion des états du contenu pédagogique
 * Aligné avec le backend sphere-school-service
 */

/**
 * États du contenu pédagogique (Teaching, Chapter, Lesson, Resource)
 * Cycle de vie: DRAFT → ACTIVE → ARCHIVED
 */
export enum PedagogicContentState {
  /** Brouillon - En cours de création, visible uniquement par le créateur */
  DRAFT = 'DRAFT',
  /** Actif - Utilisable et visible par les utilisateurs autorisés */
  ACTIVE = 'ACTIVE',
  /** Archivé - Plus utilisé mais conservé pour historique */
  ARCHIVED = 'ARCHIVED',
}

/**
 * Visibilité du contenu pédagogique (Chapter, Lesson, Resource)
 */
export enum ContentVisibility {
  /** Privé - Visible uniquement par le propriétaire */
  PRIVATE = 'PRIVATE',
  /** Établissement - Visible par tous les membres de l'établissement */
  ESTABLISHMENT = 'ESTABLISHMENT',
  /** Public - Visible par tous */
  PUBLIC = 'PUBLIC',
}

/**
 * DTO pour changer l'état d'un contenu pédagogique
 */
export interface SetStateDto {
  state: PedagogicContentState
}

/**
 * DTO pour changer la visibilité d'un contenu pédagogique
 */
export interface SetVisibilityDto {
  visibility: ContentVisibility
}

/**
 * Helper pour vérifier si un état est valide
 */
export function isValidState(state: string): state is PedagogicContentState {
  return Object.values(PedagogicContentState).includes(
    state as PedagogicContentState
  )
}

/**
 * Helper pour obtenir le label d'affichage d'un état
 */
export function getStateLabel(state: PedagogicContentState): string {
  const labels: Record<PedagogicContentState, string> = {
    [PedagogicContentState.DRAFT]: 'Brouillon',
    [PedagogicContentState.ACTIVE]: 'Actif',
    [PedagogicContentState.ARCHIVED]: 'Archivé',
  }
  return labels[state]
}

/**
 * Helper pour obtenir la couleur d'un état (pour badges UI)
 */
export function getStateColor(state: PedagogicContentState): string {
  const colors: Record<PedagogicContentState, string> = {
    [PedagogicContentState.DRAFT]: 'gray',
    [PedagogicContentState.ACTIVE]: 'green',
    [PedagogicContentState.ARCHIVED]: 'orange',
  }
  return colors[state]
}
